import React from 'react';
import { Box, Flex, Icon } from '@chakra-ui/react';
import Typography from 'src/components/Typography';

interface CounselCardProps {
  isSelected: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
}

export function CounselCard({ isSelected, onClick, icon, label }: CounselCardProps) {
  const CheckIcon = () => (
    <Icon viewBox="0 0 24 24" w="16px" h="16px">
      <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
    </Icon>
  );

  return (
    <Flex
      as="button"
      type="button"
      onClick={onClick}
      direction="column"
      align="flex-start"
      justify="space-between"
      p="16px"
      borderRadius="15px"
      border="2px solid"
      borderColor={isSelected ? 'primary.1000' : 'gray.200'}
      bg={isSelected ? 'primary.1000' : 'white'}
      transition="all 0.2s ease"
      _hover={{ borderColor: isSelected ? 'primary.1000' : 'primary.500' }}
      flex={1}
      minH="100px"
      position="relative"
    >
      <Flex justify="space-between" w="100%" align="flex-start">
        <Box bg="transparent">{icon}</Box>
        {isSelected ? (
          <Flex w="24px" h="24px" borderRadius="50%" bg="white" align="center" justify="center" color="primary.1000">
            <CheckIcon />
          </Flex>
        ) : (
          <Box w="24px" h="24px" borderRadius="50%" border="2px solid" borderColor="gray.300" />
        )}
      </Flex>
      <Typography model="body" size="normal" weight="bold" color={isSelected ? 'white' : 'primary.1000'}>
        {label}
      </Typography>
    </Flex>
  );
}
